import { PortfolioSourcesService_portfolioSourcesServiceGetStopsLatest } from '@festina/unitlink-general-types/unitlink/hooks/PortfolioSourcesStopsService_portfolioSourcesServiceGetStopsLatest'

export const useFetchPortfolioStopsLatest =
  PortfolioSourcesService_portfolioSourcesServiceGetStopsLatest.useSuspenseQuery
